import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import scorerApi from "../../services/scorerApi"
import { closeSnackbar, showErrorSnackbar, showSuccessSnackbar } from "./snackbarSlice";
import { setCurrentSeasonById } from "./seasonSlice";

export const getGameDetails = createAsyncThunk("scorer/getGameDetails", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.getGameDetails(data);
        if(response.status === 0){
            if(response?.data?.gameDetails?.seasonId){
                dispatch(setCurrentSeasonById(response?.data?.gameDetails?.seasonId));
            }
            return response?.data?.gameDetails;
        }else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const updateCurrentlyPlayingPlayers = createAsyncThunk("scorer/updateCurrentlyPlayingPlayers", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.updateCurrentlyPlayingPlayers(data);
        if(response.status === 0){
            dispatch(showSuccessSnackbar({title: response?.data?.message}));
            return response?.data;
        }else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const updateGameScore = createAsyncThunk("scorer/updateGameScore", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.updateGameScore(data);
        if(response.status === 0){
            // dispatch(showSuccessSnackbar({title: response?.data?.message, position: { vertical: "bottom", horizontal: "left"}}));
            dispatch(closeSnackbar());
            dispatch(updateGameScoreReducer(data));
            return response?.data;
        }else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const submitDetails = createAsyncThunk("scorer/submitDetails", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.submitDetails(data);
        if(response.status === 0){
            dispatch(showSuccessSnackbar({title: response?.data?.message, position: { vertical: "bottom", horizontal: "left"}}));
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({title: error?.message}));
        return rejectWithValue(error.message);
        
    }
});

export const timerEdit = createAsyncThunk("scorer/timerEdit", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.timerEdit(data);
        if(response.status === 0){
            // dispatch(showSuccessSnackbar({title: response?.data?.message}));
            dispatch(closeSnackbar());
            dispatch(updateGameTimerDetailsReducer(data))
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({title: error?.message}));
        return rejectWithValue(error.message);
        
    }
});

export const getActiveGameActions = createAsyncThunk("scorer/getActiveGameActions", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.getActiveGameActions(data);
        if(response.status === 0){
            // dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(closeSnackbar());
            return response?.data?.sportActions;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});


export const updateGameSessionByGameId = createAsyncThunk("scorer/updateGameSessionByGameId", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.updateGameSessionByGameId(data);
        if(response.status === 0){
            // dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(closeSnackbar());
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const getAllLiveGameActionsByGameId = createAsyncThunk("scorer/getAllLiveGameActionsByGameId", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.getAllLiveGameActionsByGameId(data);
        if(response.status === 0){
            // dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(closeSnackbar());
            return response?.data?.gameDetails;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});


export const awardPointsForAction = createAsyncThunk("scorer/awardPointsForAction", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.awardPointsForAction(data);
        if(response.status === 0){
            // dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(closeSnackbar());
            return response?.data;
        } else{
            // dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const addGenericCommentary = createAsyncThunk("scorer/addGenericCommentary", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await scorerApi.addGenericCommentary(data);
        if(response.status === 0){
            dispatch(showSuccessSnackbar({ title: response?.data?.message, position: { vertical: "bottom", horizontal: "left"} }));
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

const scorerSlice= createSlice({
    name : "scorer",
    initialState : {
        isLoading: false,
        error: null,
        gameDetails: {},
        liveGameActions: []
    },
    reducers: {
        updateGameScoreReducer: (state, action) => {
            if(!state.gameDetails) return;
            const { awayTeamScore, homeTeamScore } = action.payload;

            if(action.payload?.homeTeamScore){
                state.gameDetails.homeTeamScore = homeTeamScore;
            }
            if(action.payload?.awayTeamScore){
                state.gameDetails.awayTeamScore = awayTeamScore;
            }
        },
        updateGameTimerDetailsReducer: (state, action) => {
            if(!state.gameDetails) return;
            const {isGameTimerOn, lastGameTimer} = action.payload;

            if(action.payload?.isGameTimerOn){
                state.gameDetails.isGameTimerOn = isGameTimerOn;
            }
            if(action.payload?.lastGameTimer){
                state.gameDetails.lastGameTimer = lastGameTimer;
            }
        },
        updateGameDetailsReducer: (state, action) => {
            if(!state.gameDetails) return;

            if(action.payload?.awayTeamPlayer){
                const _players = [...state.gameDetails?.awayTeamPlayers ?? []];
                const playerIndex = _players.findIndex((p) => p.playerId === action.payload?.awayTeamPlayer?.playerId);

                _players[playerIndex] = {..._players[playerIndex], isCurrentlyPlaying: action.payload?.awayTeamPlayer?.isCurrentlyPlaying ?? false};

                state.gameDetails.awayTeamPlayers = [..._players];
                return;
            }else if(action.payload?.homeTeamPlayer){
                const _players = [...state.gameDetails?.homeTeamPlayers ?? []];
                const playerIndex = _players.findIndex((p) => p.playerId === action.payload?.homeTeamPlayer?.playerId);

                _players[playerIndex] = {..._players[playerIndex], isCurrentlyPlaying: action.payload?.homeTeamPlayer?.isCurrentlyPlaying ?? false};

                state.gameDetails.homeTeamPlayers = [..._players];
                return;
            }else {   
                state.gameDetails = {
                    ...state.gameDetails,
                    ...Object.fromEntries(
                        Object.entries(action.payload).filter(([, value]) => value !== undefined)
                    ),
                }
            }
        },
        addToLiveGameActions: (state, action) => {
            // if(!state.liveGameActions) return;
            const { commentary, reverse } = action.payload
            if(reverse) {
                state.liveGameActions.push(commentary);
            }else {
                state.liveGameActions.unshift(commentary);
            }
        }
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, getGameDetails, "gameDetails", "fetchGameError", "fetchingGame");
        handleAsyncThunk(builder, updateGameScore, "updateScore", "error");
        handleAsyncThunk(builder, submitDetails, "details", "error", "submitingApi");
        handleAsyncThunk(builder, timerEdit, "timerEdit", "error", "timerEditing");
        handleAsyncThunk(builder, getActiveGameActions, "gameActions", "error", "fetchingActions");
        handleAsyncThunk(builder, updateGameSessionByGameId, "updateGameSession", "error", "updatingGameSession");
        handleAsyncThunk(builder, getAllLiveGameActionsByGameId, "liveGameActions", "error", "fetchingLiveActions");
        handleAsyncThunk(builder, awardPointsForAction, "awardPointsForAction", "error", "loadingAwardPointsForAction" );
        handleAsyncThunk(builder, addGenericCommentary, "genericCommentary", "error", "loadingGenericCommentary" );
        handleAsyncThunk(builder, updateCurrentlyPlayingPlayers, "updateCurrentlyPlayingPlayers", "error", "updatingCurrentlyPlayingPlayers");
    },
});

export const { updateGameScoreReducer, updateGameTimerDetailsReducer, updateGameDetailsReducer, addToLiveGameActions } = scorerSlice.actions;

export default scorerSlice.reducer;